import "../scss/main.scss"

import React from "react"
import {useTranslation} from "react-i18next";
import HouseIcon from '@mui/icons-material/House';
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';

const Error404 = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  return (
    <div id="error-container" className="error-container">
      <h1 className="color color-medium-purple code">4<span className="flip">0</span>4</h1>
      <h5 className="color color-medium-purple message">{t("error.oopsPageDoesNotExist")}</h5>
      <IconButton
        className="color color-medium-purple"
        onClick={() => {
          navigate("/");
        }}
      >
        <HomeTwoToneIcon fontSize="large" />
      </IconButton>
    </div>
  )
}

export default Error404;

